<style scoped>
.section {
  margin-bottom: 1.5rem;
}

.buttons-row {
  margin: 10px 0 10px 0;
}

.buttons-row .col-sm-12 {
  margin-bottom: 15px;
}

#upload-badge {
  margin-left: -21.6px;
}
</style>

<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <b-row>
            <b-col>
              <b-row>
                <p>
                  For the purposes of procuring and maintaining credit from time to time in any
                  form whatsoever with Anchor Loans, LP and/or Anchor Nationwide Loans, LLC
                  (collectively, “Anchor”), for claims and demands against the Guarantor named
                  below, the Guarantor submits the following as being true and accurate
                  statement of their financial condition on the date stated and agree
                  that if any changes occur that materially reduces the means of
                  ability of the named Guarantor to pay all the claims
                  or demands against them, the Guarantor will immediately and without delay notify
                  Anchor and Anchor is so notified that it may continue to rely upon the statement
                  herein given as a true and accurate statement of the financial condition of
                  the named Guarantor as of the date written below.
                </p>
              </b-row>
              <b-row>
                <p>How would you like to provide us your financial information?</p>
              </b-row>
              <b-row class="mb-3">
                <badge
                  variant="success"
                  :yOffset="18"
                  :xOffset="-118"
                  position="relative"
                >
                  <span slot="badge" v-if="hasFinancialStatementUploaded">
                    <font-awesome-icon
                      slot="badge"
                      icon="check"
                      size="1x"
                      class="check"
                    />
                  </span>
                  <b-button
                    class="btn-anchor raised form-submit-btn m-2"
                    variant="primary"
                    @click="uploadClick">
                    Upload File
                  </b-button>
                </badge>
                <b-button
                  class="btn-anchor raised form-submit-btn m-2"
                  variant="primary"
                  @click="fillOutFormClick">
                  {{ captionFormButton }}
                </b-button>
                <b-button
                  class="btn-anchor raised form-submit-btn m-2"
                  variant="primary"
                  @click="moveToNextTab">
                  Provide Later
                </b-button>
              </b-row>
              <b-row class="d-flex justify-content-between mr-0 ml-0">
                <vue-form-generator
                  :model="model"
                  :schema="form.schemaCreditScore"
                  ref="financesForm"
                />
              </b-row>
              <div v-if="!fillOutForm">
                <b-row
                  class="d-flex justify-content-between mr-0 ml-0 mt-3"
                >
                  <h4>Total Assets and Liabilities</h4>
                </b-row>
                <b-row>
                  <b-col>
                    <vue-form-generator
                      :model="this.model"
                      :schema="form.schemaLumpSum"
                      ref="financesForm"
                    />
                  </b-col>
                </b-row>
              </div>
              <div key="1" v-if="fillOutForm">
                <b-row
                  class="d-flex justify-content-between mr-0 ml-0 mt-3"
                >
                  <h4>Itemize</h4>
                </b-row>
                <b-row>
                  <b-col>
                    <h4>Assets</h4>
                    <vue-form-generator
                      :model="this.model"
                      :schema="form.schemaAssets"
                      ref="financesForm"
                    />
                    <h4 class="mt-3">Liabilities</h4>
                    <vue-form-generator
                      :model="this.model"
                      :schema="form.schemaLiabilities"
                      ref="financesForm"
                    />
                  </b-col>
                </b-row>
              </div>
              <p>Net Worth: {{ netWorth }}</p>
              <b-row class="d-flex justify-content-end">
                <b-button
                  class="btn-anchor raised form-submit-btn"
                  variant="primary"
                  @click="clearFields"
                >
                  Clear Fields
                </b-button>
                <wizard-verified-submit-button
                  text="Update Financial Data"
                  @submit="updateFinancialData"
                />
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
    <financial-statement-upload
      ref="financialStatementModal"
      @success="onSuccessUpload"
    />
  </b-row>
</template>

<script>
import VueFormGenerator from 'vue-form-generator';
import FinancialDetailsModal from '@/components/profile/sections/tabs/financial/FinancialDetailsModal';
import IncomeContainer from '@/components/profile/sections/tabs/financial/income/IncomeContainer';
import AssetContainer from '@/components/profile/sections/tabs/financial/assets/AssetContainer';
import LiabilitiesContainer from '@/components/profile/sections/tabs/financial/liabilities/LiabilitiesContainer';
import ExplicitHint from '@/components/utils/hints/ExplicitHint';
import FinancialStatementUpload from '@/components/documents/FinancialStatementUpload';
import Badge from '@/components/utils/Badge';
import WizardVerifiedSubmitButton from '@/components/utils/buttons/form/WizardVerifiedSubmitButton';
import helper from '@/libs/helper';
import ASSETS_SCHEMA from '@/components/profile/sections/tabs/financial/resources/schemaAssets';
import LIABILITIES_SCHEMA from '@/components/profile/sections/tabs/financial/resources/schemaLiabilities';
import LUMP_SUM_SCHEMA from '@/components/profile/sections/tabs/financial/resources/schemaLumpSum';
import CREDIT_SCORE_SCHEMA from '@/components/profile/sections/tabs/financial/resources/schemaCreditScore';
import { UPDATE_FINANCES } from '@/vuex/modules/profile/types/actions';
import { DECLARATIONS_TAB } from '@/components/profile/sections/tabs/tabNumbers';

const CLEAR_FIELDS_MESSAGE = 'Clear Fields to Enable';

export default {
  components: {
    'vue-form-generator': VueFormGenerator.component,
    FinancialDetailsModal,
    IncomeContainer,
    AssetContainer,
    LiabilitiesContainer,
    ExplicitHint,
    FinancialStatementUpload,
    Badge,
    WizardVerifiedSubmitButton,
  },
  data() {
    return {
      fillOutForm: false,
      DECLARATIONS_TAB,
      form: {
        schemaAssets: { fields: [] },
        schemaLiabilities: { fields: [] },
        schemaLumpSum: { fields: [] },
        schemaCreditScore: CREDIT_SCORE_SCHEMA.schema,
      },
      model: {},
    };
  },
  computed: {
    captionFormButton() {
      if (this.fillOutForm) {
        return 'Total Assets and Liabilities';
      }
      return 'Itemize';
    },
    hasFinancialStatementUploaded() {
      const financialStatement = this.$store.getters.documents.filter(
        item => item.type === 'Financial Statement',
      )[0];
      return financialStatement.submittedCount > 0;
    },
    user() {
      return this.$store.getters.user;
    },
    netWorth() {
      const model = this.model;
      const valuesItemized = [
        model.valueInvestmentPortfolio || 0,
        model.valueRealEstateOwned || 0,
        model.currentCashOnHandInBank || 0,
        model.assetAccountsNotesReceivable || 0,
        model.assetRealEstateHomestead || 0,
        model.assetIraOrOtherRetirement || 0,
        model.assetCashValueLifeInsurance || 0,
        model.assetOtherPersonalProperty || 0,
        model.assetOtherAutos || 0,
        model.assetNotesReceivable || 0,
        model.assetsMisc || 0,
        model.assetOthers || 0,
        -1 * model.liabilityRealEstateMortgageHomestead || 0,
        -1 * model.liabilityRealEstateMortgageInvestments || 0,
        -1 * model.liabilityAccountsNotesPayableBusiness || 0,
        -1 * model.liabilityAccountsNotesPayableOther || 0,
        -1 * model.liabilityUnpaidTaxes || 0,
        -1 * model.liabilityCreditCardDebt || 0,
        -1 * model.liabilityOther || 0,
        -1 * model.liabilityInstallmentAuto || 0,
        -1 * model.liabilityInstallmentOther || 0,
        -1 * model.liabilityLifeInsuranceLoan || 0,
      ];
      const valuesTotal = [
        model.totalAssets || 0,
        -1 * model.totalLiabilities || 0,
      ];
      if (this.checkTotals) {
        return helper.currencySum(valuesTotal);
      }
      return helper.currencySum(valuesItemized);
    },
    finances() {
      const profile = this.$store.getters.profile;
      const hasProfileAndFinances = profile && profile.finances;

      return hasProfileAndFinances ? profile.finances : null;
    },
    checkTotals() {
      return !!(this.model.totalAssets || this.model.totalLiabilities);
    },
    checkItemized() {
      return !!(this.model.valueInvestmentPortfolio ||
        this.model.valueRealEstateOwned ||
        this.model.currentCashOnHandInBank ||
        this.model.assetAccountsNotesReceivable ||
        this.model.assetRealEstateHomestead ||
        this.model.assetIraOrOtherRetirement ||
        this.model.assetCashValueLifeInsurance ||
        this.model.assetOtherPersonalProperty ||
        this.model.assetOtherAutos ||
        this.model.assetNotesReceivable ||
        this.model.assetsMisc ||
        this.model.assetOthers ||

        this.model.liabilityRealEstateMortgageHomestead ||
        this.model.liabilityRealEstateMortgageInvestments ||
        this.model.liabilityAccountsNotesPayableBusiness ||
        this.model.liabilityAccountsNotesPayableOther ||
        this.model.liabilityUnpaidTaxes ||
        this.model.liabilityCreditCardDebt ||
        this.model.liabilityOther ||
        this.model.liabilityInstallmentAuto ||
        this.model.liabilityLifeInsuranceLoan ||
        this.model.liabilityInstallmentOther);
    },
  },
  methods: {
    getDocuments() {
      this.$reqs
        .get(`/users/${this.user.id}/docs`)
        .then((response) => {
          this.$store.commit('SET_DOCUMENTS', response.data);
        })
        .catch(() => {});
    },
    itemClicked(item, type) {
      const detailsModal = this.$refs.detailsModal;
      if (!detailsModal) {
        return;
      }

      detailsModal.open(type, item.id);
    },
    onSuccessUpload() {
      this.getDocuments();
      this.$refs.financialStatementModal.close();
      this.$swal.fire({
        type: 'success',
        title: 'Uploaded successfully',
      });
      this.moveToNextTab();
    },
    fillOutFormClick() {
      this.fillOutForm = !this.fillOutForm;
    },
    uploadClick() {
      this.fillOutForm = false;
      this.$refs.financialStatementModal.open();
    },
    moveToNextTab() {
      this.$emit('move-to-next-tab', DECLARATIONS_TAB);
    },
    updateFinancialData() {
      if (!this.isValid()) {
        return;
      }
      this.$reqs
        .post(
          `/users/${this.$store.getters.user.id}/profile/finance`,
          this.model,
        )
        .then((response) => {
          this.$store.dispatch(UPDATE_FINANCES, response.data.finances);
          this.$emit('tab-info-updated', 'Financial');
          this.$emit('move-to-next-tab', DECLARATIONS_TAB);
        })
        .catch(() => {});
    },
    isValid() {
      return this.$refs.financesForm.validate();
    },
    clearFields() {
      this.model.valueInvestmentPortfolio = null;
      this.model.valueRealEstateOwned = null;
      this.model.currentCashOnHandInBank = null;
      this.model.assetAccountsNotesReceivable = null;
      this.model.assetRealEstateHomestead = null;
      this.model.assetIraOrOtherRetirement = null;
      this.model.assetCashValueLifeInsurance = null;
      this.model.assetOtherPersonalProperty = null;
      this.model.assetOtherAutos = null;
      this.model.assetNotesReceivable = null;
      this.model.assetsMisc = null;
      this.model.assetOthers = null;

      this.model.liabilityRealEstateMortgageHomestead = null;
      this.model.liabilityRealEstateMortgageInvestments = null;
      this.model.liabilityAccountsNotesPayableBusiness = null;
      this.model.liabilityAccountsNotesPayableOther = null;
      this.model.liabilityUnpaidTaxes = null;
      this.model.liabilityCreditCardDebt = null;
      this.model.liabilityOther = null;
      this.model.liabilityInstallmentAuto = null;
      this.model.liabilityInstallmentOther = null;
      this.model.liabilityLifeInsuranceLoan = null;

      this.model.totalAssets = null;
      this.model.totalLiabilities = null;

      this.form.schemaAssets.fields = helper.copy(ASSETS_SCHEMA.schema.fields);
      this.form.schemaLiabilities.fields = helper.copy(LIABILITIES_SCHEMA.schema.fields);
      this.form.schemaLumpSum.fields = helper.copy(LUMP_SUM_SCHEMA.schema.fields);
    },
  },
  mounted() {
    const profile = this.$store.getters.profile;
    const hasProfileAndFinances = profile && profile.finances;
    if (hasProfileAndFinances) {
      this.model = helper.copy(profile.finances);
    }
    this.fillOutForm = !(this.model.totalAssets || this.model.totalLiabilities);
    this.form.schemaAssets.fields = helper.copy(ASSETS_SCHEMA.schema.fields);
    this.form.schemaLiabilities.fields = helper.copy(LIABILITIES_SCHEMA.schema.fields);
    this.form.schemaLumpSum.fields = helper.copy(LUMP_SUM_SCHEMA.schema.fields);
  },
  watch: {
    checkTotals(newValue) {
      if (newValue) {
        this.form.schemaAssets.fields.forEach((field) => {
          Object.assign(field, { disabled: 'disabled', hint: CLEAR_FIELDS_MESSAGE });
        });
        this.form.schemaLiabilities.fields.forEach((field) => {
          Object.assign(field, { disabled: 'disabled', hint: CLEAR_FIELDS_MESSAGE });
        });
      }
    },
    checkItemized(newValue) {
      if (newValue) {
        this.form.schemaLumpSum.fields.forEach((field) => {
          Object.assign(field, { disabled: 'disabled', hint: CLEAR_FIELDS_MESSAGE });
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/profile/sections/tabs/financial/FinancialContent.vue